import styled from 'styled-components';

export const AddToPopular = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  // justify-content: center;
  width: 140px;
  gap: 9px;
  color: ${({ theme, isPopular }) => (isPopular ? theme.colors.grey600 : theme.colors.grey500)};
`;

export const AddToPopularIcon = styled.span`
  color: ${({ theme }) => theme.colors.blueDark};

  font-weight: 900;
  margin-inline-start: 10px !important;

  &:after {
    font-family: icomoon;
    font-size: 20px;
    ${({ isPopular }) =>
      isPopular
        ? `content: '\\e95c';
    `
        : `content: '\\e95a';
    `};
  }
`;
